module.exports = __webpack_public_path__ + "static/media/AtlasGrotesk-Bold-Cy-Web.d576768b.woff2";